<template>
  <transition
    name="page"
    enter-active-class="animated slideInRight"
    leave-active-class="animated slideOutRight"
  >
    <div class="page">
      <div class="page-wrapper"><slot></slot></div>
    </div>
  </transition>
</template>

<script>
export default {
  created () {
    document.body.style.overflow = 'hidden'
    document.body.style.height = '100%'
  },
  destroyed () {
    document.body.style.overflow = ''
    document.body.style.height = ''
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.page {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-color: var(--colorWhite);

  & .page-wrapper {
    display: table;
    vertical-align: middle;
    width: inherit;
    height: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Page.vue